import React, { useEffect, useState, useCallback } from "react";
import { Badge, Dropdown, List, Button, Empty, Tag } from "antd";
import { BellOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { getNotifications, readNotification, readAllNotifications } from "../api/client";
import { useAuth } from "../context/AuthContext";

const KIND = {
  mention: { l: "منشن", c: "blue" }, assignment: { l: "واگذاری", c: "purple" },
  qc: { l: "کنترل کیفیت", c: "cyan" }, approval: { l: "تأیید", c: "gold" },
  discrepancy: { l: "مغایرت", c: "red" }, import: { l: "ایمپورت", c: "geekblue" }, info: { l: "اطلاع", c: "default" },
};

export default function NotificationBell() {
  const navigate = useNavigate();
  const { isAuthed } = useAuth();
  const [data, setData] = useState({ unread: 0, items: [] });
  const [open, setOpen] = useState(false);

  const load = useCallback(() => {
    if (!isAuthed) return;
    getNotifications().then((r) => setData(r.data)).catch(() => {});
  }, [isAuthed]);

  useEffect(() => {
    load();
    const t = setInterval(load, 60000);  // هر یک دقیقه
    return () => clearInterval(t);
  }, [load]);

  const onClick = async (n) => {
    if (!n.is_read) { try { await readNotification(n.id); } catch {} }
    setOpen(false); load();
    if (n.link) navigate(n.link);
  };
  const markAll = async () => { try { await readAllNotifications(); } catch {} load(); };

  const panel = (
    <div style={{ width: 340, maxHeight: 420, overflow: "auto", background: "var(--surface,#fff)", borderRadius: 10, boxShadow: "0 6px 24px rgba(0,0,0,.16)", padding: 8 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "4px 8px" }}>
        <b>اعلان‌ها</b>
        {data.unread > 0 && <Button type="link" size="small" onClick={markAll}>خواندنِ همه</Button>}
      </div>
      {data.items.length ? (
        <List size="small" dataSource={data.items} renderItem={(n) => (
          <List.Item style={{ cursor: "pointer", background: n.is_read ? "transparent" : "var(--bg-subtle,#f0f7ff)", borderRadius: 8, padding: "8px 10px" }}
            onClick={() => onClick(n)}>
            <div style={{ width: "100%" }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <b style={{ fontSize: 13 }}>{n.title}</b>
                <Tag color={KIND[n.kind]?.c} style={{ margin: 0 }}>{KIND[n.kind]?.l || n.kind}</Tag>
              </div>
              {n.message && <div style={{ fontSize: 12, color: "#888" }}>{n.message}</div>}
            </div>
          </List.Item>
        )} />
      ) : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="اعلانی نیست" />}
    </div>
  );

  return (
    <Dropdown open={open} onOpenChange={(o) => { setOpen(o); if (o) load(); }}
      trigger={["click"]} placement="bottomLeft" dropdownRender={() => panel}>
      <button className="gx-icon-btn" title="اعلان‌ها">
        <Badge count={data.unread} size="small"><BellOutlined /></Badge>
      </button>
    </Dropdown>
  );
}
